import axios from 'axios'

export default {
    getCourse({ dispatch, commit }, data) {
        axios
            .get('/api/Course/GetCourse?CourseId='+data)
            .then(response => {
                commit('SET_COURSE_RESULT', response.data.data.$values)
            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },

    getCourseDtl({ dispatch, commit }, data) {
        axios
            .get('/api/Course/GetCourseDtl?CourseId='+data)
            .then(response => {
                commit('SET_COURSE_DTL_RESULT', response.data.data)
            })
            .catch(error => {
                dispatch('errorGETHandler', error.response, { root: true });
            })
    },


}
